import React from 'react';
import { isNotEmpty, parseClasses } from '../../lib/ep';

import HTMLContainer from '../builder/HTMLContainer';
import ModuleHeader from './ModuleHeader';

export const ProfileModule = (props) => {
	let _props = {...props};
	let _classes = _props?._class ?? {};
	if(_classes.padding == undefined) _classes.padding = 'normal';
	_props._class = _classes;

	return (
		<Module
			is_profile={true}
			{..._props}
		/>
	)
}

const Module = (props) => {
	const force_show = props?.force_show ?? false;

	if(!force_show && props.children == undefined) return null;

	const with_shadow = props?.with_shadow ?? true;

	const is_profile = props?.is_profile ?? false;
	const is_gapped = props?.is_gapped ?? true;

	const has_title = props?.title ?? false;
	const title = (has_title !== false) ? (has_title?.label ?? has_title) : null;

	let classes = ['page_container', 'is_module'];
	if(with_shadow) classes.push('shadow_small');
	
	let classname = parseClasses(classes.join(" "), props._class, 'container');
	const is_padded = props?._class?.padding ?? 'big';
	
	if(has_title !== false && is_padded !== false && !isNotEmpty((props?._class ?? {}), 'padding')) {
		classname += ` ${(!is_profile) ? 'gui_not_padded_in_top' : 'gui_padded_in_top'}`;
	}

	if(is_gapped === false) classname += ' not_gapped';

	let header_class = props?.header_class ?? {};
	if(header_class.other == undefined) header_class.other = '';
	header_class.other += ' section_title';

	return (
		<HTMLContainer type={props?.type ?? 'article'} id={props.id} className={classname} style={props.style}>
			<ModuleHeader
				{...has_title}
				_class={header_class}
				subtitle={props.subtitle}
				tooltip={props.tooltip}
				actions={props.actions}
				action_container_props={props.action_container_props}
				autotranslate={props.autotranslate}
				icon={props.icon}
			>{title}</ModuleHeader>
			
			{props.children}
		</HTMLContainer>
	)
};

export default Module;